import {
  TransactionSearchFields,
  TransactionSearchTypes,
  TransactionSearchValues,
  TransactionSelectFilterTypes,
} from './transactionConstants'

const {
  PAYMENT_ACTION_STATUS,
  PAYMENT_STATUS,
  STATUS,
  CHANNEL_TYPE,
  STORE_STORE_ID,
} = TransactionSearchFields
const { MUST, SHOULD, MUST_NOT } = TransactionSearchTypes
const {
  ANNULLED,
  CREDITABLE,
  CREDITED,
  FROZEN,
  DEBITABLE,
  DEBITED,
  PARTLY_CREDITED,
  PARTLY_DEBITED,
  ECOMMERCE,
  UPGRADED,
  MERCHANT_API,
} = TransactionSearchValues

const TransactionFilterQueries = {
  annulled: [
    {
      field: STATUS,
      value: ANNULLED,
      type: MUST,
      _id: Math.random(),
    },
  ],
  credited: [
    {
      field: PAYMENT_STATUS,
      type: MUST,
      value: CREDITED,
      _id: Math.random(),
    },
    {
      field: PAYMENT_STATUS,
      type: MUST_NOT,
      value: CREDITABLE,
      _id: Math.random(),
    },
  ],
  debit: [
    {
      _id: Math.random(),
      field: PAYMENT_STATUS,
      type: MUST,
      value: DEBITABLE,
    },
    {
      field: STATUS,
      value: FROZEN,
      type: MUST_NOT,
      _id: Math.random(),
    },
    {
      _id: Math.random(),
      field: STATUS,
      type: SHOULD,
      value: 'APPROVED',
    },
    {
      field: PAYMENT_STATUS,
      value: DEBITED,
      type: MUST_NOT,
      _id: Math.random(),
    },
  ],
  debited: [
    {
      field: PAYMENT_STATUS,
      type: MUST_NOT,
      value: CREDITED,
      _id: Math.random(),
    },
    {
      field: PAYMENT_STATUS,
      type: MUST,
      value: DEBITED,
      _id: Math.random(),
    },
    {
      field: PAYMENT_ACTION_STATUS,
      type: MUST_NOT,
      value: PARTLY_DEBITED,
      _id: Math.random(),
    },
  ],
  frozen: [
    {
      _id: Math.random(),
      field: STATUS,
      type: MUST,
      value: FROZEN,
    },
  ],
  partlyCredited: [
    {
      field: PAYMENT_ACTION_STATUS,
      type: MUST,
      value: PARTLY_CREDITED,
      _id: Math.random(),
    },
  ],
  partlyDebited: [
    {
      _id: Math.random(),
      field: PAYMENT_ACTION_STATUS,
      type: MUST,
      value: PARTLY_DEBITED,
    },
  ],
  eCommerce: [
    {
      _id: Math.random(),
      field: CHANNEL_TYPE,
      type: MUST,
      value: ECOMMERCE,
    },
  ],
  merchantPortal: [
    {
      _id: Math.random(),
      field: CHANNEL_TYPE,
      type: MUST_NOT,
      value: ECOMMERCE,
    },
    {
      _id: Math.random(),
      field: CHANNEL_TYPE,
      type: MUST_NOT,
      value: UPGRADED,
    },
    {
      _id: Math.random(),
      field: CHANNEL_TYPE,
      type: MUST_NOT,
      value: MERCHANT_API,
    },
  ],
  merchantApi: [
    {
      _id: Math.random(),
      field: CHANNEL_TYPE,
      type: MUST,
      value: MERCHANT_API,
    },
  ],
  all: [],
}

export const buildTransactionFilterQuery = types => {
  const filters = []

  const filterConditions = {
    transactionsFilter: types.transactionsFilter,
    channelFilter: types.channelFilter,
    selectedStoreId: types.selectedStoreId,
  }

  Object.keys(filterConditions).forEach(key => {
    const filterType = filterConditions[key]

    if (filterType && filterType !== TransactionSelectFilterTypes.ALL) {
      if (key === 'selectedStoreId') {
        filters.push({
          _id: Math.random(),
          field: STORE_STORE_ID,
          value: filterType,
          type: MUST,
        })
      } else {
        filters.push(...TransactionFilterQueries[filterType])
      }
    }
  })

  return filters.length > 0
    ? filters
    : TransactionFilterQueries[TransactionSelectFilterTypes.ALL]
}
